/* eslint-disable complexity */
/* eslint-disable functional/no-loop-statement */
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useEffect, useMemo, useState } from 'react';

export const useCentralContainerRemainingSpace = () => {
	const theme = useTheme();
	const [windowWidth, setWindowWidth] = useState(0);
	const isLgDown = useMediaQuery(theme.breakpoints.down('lg'));
	const lgWidth = theme.breakpoints.values.lg;

	useEffect(() => {
		if (typeof window === 'undefined') {
			return;
		}

		setWindowWidth(window?.innerWidth);

		const handleResize = () => {
			setWindowWidth(window?.innerWidth);
		};

		window?.addEventListener('resize', handleResize);

		return () => {
			window?.removeEventListener('resize', handleResize);
		};
	}, []);

	const totalWidth = useMemo(() => {
		const width = isLgDown ? windowWidth - 40 : windowWidth * 0.9;
		return width > lgWidth ? lgWidth : width;
	}, [isLgDown, windowWidth, lgWidth]);

	const spacing = useMemo(() => {
		const spacing = (windowWidth - totalWidth) / 2;
		return spacing;
	}, [windowWidth, totalWidth]);

	return `${spacing}px`;
};
